// @flow
import type { Experience } from 'app/common/lib/react/experiences/experienceUtils';

const shouldShowHomeFeedFirstPinPlacement = (experience: Experience) =>
  !!(
    experience &&
    experience.type === PCONST.thrift.ExperienceType.FIRST_PIN &&
    experience.experience_id !== PCONST.thrift.Experience.NOOP
  );

// NOTE: Please keep this in sync with the resource options in AuthHomePage.js
// If you're updating resource options here, please test server-side rendering
// NOTE: Please also keep this in sync with the resource options in www/Main.js
// If you're updating resource options here, please test homefeed prefetching
// (talk to @jchan or @ablair)
const userHomefeedResourceOptions = ({
  experience,
  inNux,
  staticFeed,
  viewerIsPartner,
}: {|
  experience: Experience,
  inNux?: boolean,
  staticFeed: boolean,
  viewerIsPartner: boolean,
|}) => ({
  field_set_key: viewerIsPartner ? 'hf_grid_partner' : 'hf_grid',
  in_nux: inNux,
  prependPartner: viewerIsPartner,
  prependUserNews: shouldShowHomeFeedFirstPinPlacement(experience),
  static_feed: staticFeed,
});

export default userHomefeedResourceOptions;
